import { useMemo } from 'react';
import { XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar } from 'recharts';
import { formatNumber } from '../../utils';
import { PERMISSIONS } from '../../constants';
import useDashboardContext from '../../hooks/useDashboardContext';
import { DashboardWrapper, RotatedAxisTick } from '../../components';
import { orderBy } from 'lodash';

const colors = {
    area01: "#79CF62",
    area02: "#7869DF",
};

const chartMargin = { top: 20, bottom: 40 };
const yAxisDomain = [0, 100];
const yAxisTickFormatter = (value) => `${value}%`;
const tooltipFormatter = (value) => `${formatNumber(parseFloat(value) || 0)}% dos abastecimentos`;
const tooltipLabelFormatter = (label) => `Combustível: ${label}`;
const tooltipItemStyle = { color: '#333', fontSize: '14px' };
const tooltipContentStyle = { backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' };

const formatToPercentage = (value, total) => {
    return (((parseInt(value) * 100) / total) || 0).toFixed(2);
};

export const FillingCompletelyByFuel = () => {
    const { fillingBehaviorData, fillingBehaviorLoading } = useDashboardContext();

    const chartData = useMemo(() => {
        if (!fillingBehaviorData?.byFuel) return null;

        const formattedData = fillingBehaviorData.byFuel.map((element) => ({
            ...element,
            filling_completely: formatToPercentage(element.filling_completely, element.total),
            filling_limit: formatToPercentage(element.filling_limit, element.total),
        }));

        return orderBy(formattedData, ['filling_completely'], ['desc']);
    }, [fillingBehaviorData]);

    const chartContent = useMemo(() => (
        <BarChart data={chartData || []} margin={chartMargin}>
            <CartesianGrid strokeDasharray="3 3" stroke="#dfdfdf" />
            <XAxis dataKey="fuel_name" tick={<RotatedAxisTick fontSize={12} />} interval={0} height={50} />
            <YAxis domain={yAxisDomain} tickFormatter={yAxisTickFormatter} width={40} height={80} />
            <Tooltip
                formatter={tooltipFormatter}
                labelFormatter={tooltipLabelFormatter}
                itemStyle={tooltipItemStyle}
                contentStyle={tooltipContentStyle}
            />
            <Bar dataKey="filling_completely" name="Encheu tanque" fill={colors.area01} barSize={40} isAnimationActive={true} />
            <Bar dataKey="filling_limit" name="Não encheu tanque" fill={colors.area02} barSize={40} isAnimationActive={true} />
        </BarChart>
    ), [chartData]);

    return (
        <DashboardWrapper
            title="Encher tanque por combustíveis"
            permission={PERMISSIONS.FILLINS_CHART}
            aspectRatio={6.0 / 2.5}
            count={chartData?.length}
            loading={!fillingBehaviorData && fillingBehaviorLoading}
            content={chartContent}
        />
    );
};
